import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class Popup extends Component {
    constructor(props) {
        super(props);
    }

    handleClose() {

        if (this.props.help === 1) {
            this.props.alertPopUpResult(this.props.help);
        } else {
            // window.location.href = "https://producermax.com/";
            this.props.alertPopUpResult(this.props.help);
        }
    }

    render() {
        return (
            <div>
                <div style={{ position: "fixed" }} >
                    <Modal show="show" size={this.props.help === 1 ? "lg" : "sm"}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        {this.props.help !== 1 && (
                            <Modal.Header>
                                <Modal.Title><h5 className="alertTitle">{"Success"}</h5></Modal.Title>
                            </Modal.Header>
                        )}
                        {/* <div style={{ height: "395px", width: "100%", overflow: "auto", position: "relative" }}> */}
                        <Modal.Body className="alertAgentDtls">
                            {this.props.help === 1 ? (
                                <div className="row">
                                    {this.props.config.InstructionsVideo_Enable === true &&
                                        (
                                            <div className="col alrtVidoInstructions">
                                                <h5 className="alertTitle centerAlign">{"Guide"}</h5>
                                                <h6>For step-by-step</h6>
                                                <h6>instructions,</h6>
                                                <h6><a href={this.props.config.InstructionsVideo_Link} target="_blank">click to watch video</a></h6>
                                            </div>
                                        )}
                                    <div className="col">
                                        <div className="alertAgentDtls">
                                            <h5 className="alertTitle centerAlign">{"Contact Agent"}</h5>
                                            <h6 className="agentName">Name  :  {this.props.agentDetails.AgentFullName}</h6>
                                            <h6>Phone  :  {this.props.agentDetails.AgentPhone}</h6>
                                            <h6>Email-Id  : <a href={"mailto:" + this.props.agentDetails.AgentEmail}>{this.props.agentDetails.AgentEmail}</a></h6>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    < h6 > Thank you for signing the SOA form. <strong>{this.props.agentDetails.AgentFullName}</strong> will contact you.</h6>
                                    <h6>You can close the browser now.</h6>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="warning" onClick={this.handleClose.bind(this)}>
                                {this.props.help === 1 ? "Close" : "Ok"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div >
        );
    }
}
export default Popup;